var s, e;
function t() {
  if (e) return s;
  e = 1;
  return s = class {
    constructor(s) {
      this.result = {
        meta: {},
        addresses: []
      }, this.text = s, this.html = void 0, this.aggressive = void 0, this.addressesHaveLineBreaks = void 0, this.addressesPerLine = void 0, this.customParameters = {};
    }
    addCustomParameter(s, e) {
      this.customParameters[s] = e;
    }
  };
}
export { t as __require };